import React, { useState, useEffect, Fragment } from "react"
import PropTypes from "prop-types"
import { Row, Col, Button, Input, Label } from "reactstrap"
import { Link, withRouter } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { removeDiacritics } from "common/strings"

import {
  getProfiles,
  getCustomers,
  addUser,
  addUserClean,
  editUser,
  getGroups,
  getPositions,
  getUser,
  getUsers,
  getUsersByRole,
  editUserClean,
} from "store/actions"
import SweetAlert from "react-bootstrap-sweetalert"
import {
  AvForm,
  AvField,
  AvInput,
  AvGroup,
} from "availity-reactstrap-validation"

const HubUsersSoftskills = props => {
  const insert = props.insert ?? true
  const id = props.id ?? 0

  const [record, setRecord] = useState(false)

  const [formError, setFormError] = useState(false)
  const [ocupationField, setOcupationField] = useState(false)
  const [n4Field, setN4Field] = useState(false)
  const [n5Field, setN5Field] = useState(false)
  const [n6Field, setN6Field] = useState(false)
  const [n7Field, setN7Field] = useState(false)
  const [profile, setProfile] = useState(0)
  const [filteredGroups, setFilteredGroups] = useState([])
  const [group, setGroup] = useState(0)
  const [userByRoleTag, setUserByRoleTag] = useState("")

  const dispatch = useDispatch()

  const {
    users,
    usersByRole,
    profiles,
    groups,
    positions,
    apiClients,
    loading,
    done,
    user,
    insertedUser,
    insertedUserError,
    getUserLoading,
    getUserDone,
    editUserLoading,
    editUserError,
    editUserDone,
    whoIAm,
  } = useSelector(state => ({
    users: state.UsersList.users,
    usersByRole: state.UsersList.usersByRole,
    profiles: state.ProfilesList.profiles,
    groups: state.GroupsList.groups,
    positions: state.PositionsList.positions,
    apiClients: state.CustomersList.customers,
    loading: state.UserAdd.loading,
    done: state.UserAdd.done,
    insertedUser: state.UserAdd.user,
    insertedUserError: state.UserAdd.error,
    user: state.UserEdit.user,
    getUserLoading: state.UserEdit.loading,
    getUserDone: state.UserEdit.done,
    editUserLoading: state.UserEdit.updateLoading,
    editUserDone: state.UserEdit.updateDone,
    editUserError: state.UserEdit.error,
    whoIAm: state.Profile.user,
  }))

  const userId = whoIAm?.idUsuario ?? 0
  const profileId = whoIAm?.idRol ?? 0

  const userInfo =
    !insert && user !== undefined
      ? { ...user }
      : {
          softskillsProfileId: 0,
          softskillsRegionId: 0,
          softskillsPositionId: 0,
        }

  const softskillsProfileId = userInfo.softskillsProfileId ?? 0

  useEffect(() => {
    if (!insert && softskillsProfileId !== 0) {
      setRecord(true)
    }
  }, [insert, softskillsProfileId])

  const handleSubmit = (event, errors, values) => {
    if (!record) {
      props.onConfirm({
        softskillsProfileId: null,
        softskillsRegionId: null,
        softskillsPositionId: null,
      })
      return
    }

    if (errors.length > 0) {
      setFormError(true)
      return
    }
    setFormError(false)
    const softskillsProfileId = parseInt(values.softskillsProfileId)
    const softskillsRegionId = parseInt(values.softskillsRegionId)
    const softskillsPositionId = parseInt(values.softskillsPositionId)

    const request = {
      softskillsProfileId: softskillsProfileId,
      softskillsRegionId: softskillsRegionId,
      softskillsPositionId: softskillsPositionId,
    }

    props.onConfirm(request)
  }

  return (
    <AvForm className="form-horizontal" onSubmit={handleSubmit}>
      {insert && insertedUserError !== "" && (
        <div className="alert alert-danger">
          Ocurrió un error al registrar usuario: {insertedUserError.error}
        </div>
      )}
      {!insert && editUserError !== "" && (
        <div className="alert alert-danger">
          Ocurrió un error al editar usuario: {editUserError.error}
        </div>
      )}
      <Row>
        <Col>
          <h3 className="mb-4">Habilidades Blandas</h3>
        </Col>
      </Row>
      {softskillsProfileId === 0 && (
        <Row>
          <Col size={{ span: 4, offset: 4 }} className="mb-4">
            <AvGroup check>
              <AvInput
                name="celf"
                type="checkbox"
                checked={record}
                onChange={value => setRecord(value.target.checked)}
              />
              <Label for="celf">
                El usuario será participante en esta aplicación.{" "}
                <a
                  href="https://www.henkel.mx/declaracion-de-proteccion-de-datos#pageID=560414"
                  target="_blank"
                  rel="noreferrer"
                >
                  Leer TyC
                </a>
                .
              </Label>
            </AvGroup>
          </Col>
        </Row>
      )}
      {record && (
        <Fragment>
          <Row className="mb-3">
            <Col md={12}>
              {usersByRole !== undefined && (
                <AvField
                  name="softskillsProfileId"
                  value={userInfo.softskillsProfileId}
                  label="* Perfil:"
                  className="form-control"
                  placeholder=""
                  type="select"
                  onChange={event => {}}
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Este campo es requerido",
                    },
                  }}
                >
                  <option key={0} value="">
                    -- Seleccione perfil --
                  </option>
                  <option value={1}>S1 - Admin</option>
                  <option value={2}>S2 - Head of Sales</option>
                  <option value={3}>S3 - Regional Sales Manager</option>
                  <option value={4}>S4 - Learner</option>
                </AvField>
              )}
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={12}>
              {usersByRole !== undefined && (
                <AvField
                  name="softskillsRegionId"
                  value={userInfo.softskillsRegionId}
                  label="* Región:"
                  className="form-control"
                  placeholder=""
                  type="select"
                  onChange={event => {}}
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Este campo es requerido",
                    },
                  }}
                >
                  <option key={0} value="">
                    -- Seleccione región --
                  </option>
                  <option value={1}>Admin Plataforma</option>
                  <option value={5}>Bajío</option>
                  <option value={6}>Centro</option>
                  <option value={4}>Especificaciones</option>
                  <option value={2}>National</option>
                  <option value={3}>Negocios Institucionales</option>
                  <option value={7}>Norte</option>
                  <option value={8}>Sureste</option>
                </AvField>
              )}
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={12}>
              {usersByRole !== undefined && (
                <AvField
                  name="softskillsPositionId"
                  value={userInfo.softskillsPositionId}
                  label="* Ocupación:"
                  className="form-control"
                  placeholder=""
                  type="select"
                  onChange={event => {}}
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Este campo es requerido",
                    },
                  }}
                >
                  <option key={0} value="">
                    -- Seleccione ocupación --
                  </option>
                  <option value={7}>Head of Sales</option>
                  <option value={4}>Key Account Executive</option>
                  <option value={5}>Key Account Manager</option>
                  <option value={2}>Regional Sales Manager</option>
                  <option value={1}>Sales Excelence Manager</option>
                  <option value={3}>Technical Sales Advisor</option>
                  <option value={6}>Otro</option>
                </AvField>
              )}
            </Col>
          </Row>
        </Fragment>
      )}
      <Row className="mb-3">
        <Col xl={8} lg={8} md={8} sm={8} xs={0}></Col>
        <Col xl={2} lg={2} md={2} sm={2} xs={6}>
          <button
            type="button"
            onClick={() => props.onCancel()}
            className="btn btn-warning btn-block"
          >
            Regresar
          </button>
        </Col>
        <Col xl={2} lg={2} md={2} sm={2} xs={6}>
          <Button
            className={`float-right ${loading ? "disabled" : ""} btn-block`}
            type="submit"
          >
            {!loading && <span>Finalizar</span>}
            {loading && <span>Guardando...</span>}
          </Button>
        </Col>
      </Row>
    </AvForm>
  )
}

HubUsersSoftskills.propTypes = {
  id: PropTypes.number,
  insert: PropTypes.bool,
  history: PropTypes.object,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
}

export default withRouter(HubUsersSoftskills)
